export default __webpack_public_path__ + "static/media/users.ca91a14f.svg";